import React from 'react';
import { Button } from './Button';
import { SectionWrapper } from './SectionWrapper';
import { Sparkles } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="bg-navy text-cream relative overflow-hidden" data-id="element-90">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-91">
        <div className="absolute top-10 left-10 text-gold opacity-20" data-id="element-92">
          <Sparkles size={24} data-id="element-93" />
        </div>
        <div className="absolute top-40 right-20 text-gold opacity-20" data-id="element-94">
          <Sparkles size={32} data-id="element-95" />
        </div>
        <div className="absolute bottom-20 left-1/3 text-gold opacity-10" data-id="element-96">
          <Sparkles size={48} data-id="element-97" />
        </div>
      </div>

      <SectionWrapper className="pt-32 pb-24 md:pt-40 md:pb-32" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-99">
          <div className="flex flex-col space-y-8 z-10" data-id="element-100">
            <div className="inline-block border border-gold/30 text-gold px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase self-start" data-id="element-101">
              Página de Ventas: Protocolo de Alerta
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-white" data-id="element-102">
              Dejó de ser "cansancio":{' '}
              <span className="text-gold italic" data-id="element-103">Guía de rescate</span> para la
              madre profesional que no duerme.
            </h1>

            <h2 className="text-lg md:text-xl text-cream/80 font-sans leading-relaxed" data-id="element-104">
              Recupera tus noches y protege tu carrera con el Protocolo de 72
              Horas diseñado para bebés exigentes y madres que trabajan.
            </h2>

            <div className="pt-4" data-id="element-105">
              <Button onClick={scrollToOffer} data-id="element-106">
                Quiero recuperar mis noches y mi carrera
              </Button>
              <p className="text-cream/50 text-sm mt-4 font-sans" data-id="element-107">
                Acceso inmediato. Tu descanso empieza hoy.
              </p>
            </div>
          </div>

          <div className="relative z-10 flex justify-center lg:justify-end" data-id="element-108">
            <div className="relative w-full max-w-md" data-id="element-109">
              {/* Subtle glow behind image */}
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-90" data-id="element-110"></div>
              <img src="https://cdn.magicpatterns.com/uploads/8fJCvstGcySDudesDBdwki/heylloyd-image-1777673781625.png" alt="Protocolo de Alerta en dispositivos" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-111" />
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}